export default __webpack_public_path__ + "static/media/Data-not-found3.10e4a5f6.png";